import theme from "@styles/theme";
import Typography from "@components_v2/typography/typography";
import React, { useState } from "react";
import EditButton from "@components_v2/edit-button/edit-button";
import { useTranslation } from "react-i18next";
import Tooltip from "@components_v2/Tooltip/tooltip";
import { Box, ClickAwayListener, Grid, IconButton } from "@mzc-pdc/ui";
import { IconInfoCircle } from "@mzc-cloudplex/icons";

const PanelPropertyTitle = ({
    variant,
    subtitle,
    color,
    required,
    showEditButton,
    editButtonDisabled,
    onClickEditButton,
    tooltip,
}) => {
    const { t } = useTranslation();

    const [tooltipOpen, setTooltipOpen] = useState(false);

    return (
        <>
            <Typography variant={variant} required={required} color={color} gutterBottom>
                {subtitle}
            </Typography>
            {tooltip && (
                <ClickAwayListener
                    onClickAway={() => {
                        if (tooltipOpen) setTooltipOpen(!tooltipOpen);
                    }}
                >
                    <Tooltip
                        title={tooltip}
                        onClose={() => setTooltipOpen(false)}
                        open={tooltipOpen}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        placement={"bottom"}
                    >
                        <IconButton
                            circled
                            size={"small"}
                            onClick={() => setTooltipOpen(!tooltipOpen)}
                            sx={{ ml: theme.spacing(1) }}
                        >
                            <IconInfoCircle size={16} color={"secondary"} />
                        </IconButton>
                    </Tooltip>
                </ClickAwayListener>
            )}
            {showEditButton && <EditButton disabled={editButtonDisabled} onClick={onClickEditButton} />}
        </>
    );
};

export default PanelPropertyTitle;
